import React from 'react';
import cn from '@/utils/cn';

const CheckboxClass = cn([
  'w-4',
  'h-4',
  'rounded',
  'border-emerge-navy-4',
  'text-emerge-teal',
  'focus:ring-transparent',
  'cursor-pointer',
  'disabled:cursor-not-allowed',
  'disabled:opacity-40'
]);

export const CheckboxCellClass = cn(['p-4', 'w-4', 'whitespace-nowrap']);

interface CheckboxCellProps {
  checked: boolean;
  onChange: () => void;
  ariaLabel?: string;
  disabled?: boolean;
}

export const CheckboxCell: React.FC<CheckboxCellProps> = ({
  checked,
  onChange,
  ariaLabel = 'Select row',
  disabled = false
}) => (
  <input
    type="checkbox"
    checked={checked}
    onChange={onChange}
    onClick={(e) => e.stopPropagation()}
    aria-label={ariaLabel}
    disabled={disabled}
    className={CheckboxClass}
  />
);
